<template>
  <v-card class="rounded-card card-shadow" color="primary">
    <v-card-title class="white--text font-weight-bold">
      <v-icon xlarge left color="white">mdi-credit-card-outline</v-icon>
      PMP Global
    </v-card-title>
    <v-card-text v-if="!loading && !indicadores"
                 class="text--primary dashboard-empty-div d-flex align-center justify-center">
      <span class="white--text font-weight-bold">
        Nenhum dado encontrado
      </span>
    </v-card-text>
    <v-card-text v-else
                 :style="{height: cardHeight}"
                 class="text--primary">
      <div v-show="loading">
        <px-circular-loading/>
      </div>
      <div v-if="!loading && indicadores"
           class="d-flex flex-column justify-space-around fill-height">
        <div class="d-flex justify-space-around">
          <div class="text-center">
            <span class="white--text headline font-weight-bold">
              {{ indicadores.pmpGeral || 0 }} dias
            </span>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import IndicadoresService from '@/modules/dashboard/dashboard-service';

export default {
  props: {
    cardHeight: {
      type: String,
      default: '260px',
    },
  },
  data() {
    return {
      compras: null,
      loading: false,
      indicadores: null,
    };
  },
  methods: {
    getCompras() {
      this.loading = true;
      IndicadoresService.getComprasPrazoMedio()
        .then((response) => {
          this.indicadores = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getCompras();
  },
};
</script>
<style scoped>
.dashboard-empty-div {
  height: 280px;
}
</style>
